import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import store, { toggleSummary } from '@carvana/purchase-store';
import { currency } from '@carvana/purchase-utils';
import * as sc from '../../widget-bar.styles';
import { AnalyticsContext } from '@carvana/eventable-clickstream';

const CartWidget = props => {
  const { display, isMobile, vehicleAvailable, vehicle } = props;
  const { totalPrice } = useSelector(state => state.vehicle);
  const { trackEvent } = useContext(AnalyticsContext);

  if (!display && !isMobile) return null;

  return (
    <sc.WidgetWrapper
      onClick={() => {
        trackEvent('pp_clicked_order_summary');
        if (vehicle) store.dispatch(toggleSummary());
      }}
      style={vehicle && { cursor: 'pointer' }}
      hide={!display}
    >
      {vehicleAvailable && <sc.Divider />}
      <sc.CartIcon />
      <sc.TextWrapper>
        <sc.WidgetLabel isMobile={isMobile}>
          {isMobile ? currency(totalPrice) : 'Carvana Total Price'}
        </sc.WidgetLabel>
        {!isMobile && <sc.WidgetValue>{currency(totalPrice)}</sc.WidgetValue>}
      </sc.TextWrapper>
    </sc.WidgetWrapper>
  );
};

CartWidget.propTypes = {
  display: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  vehicleAvailable: PropTypes.bool.isRequired
};

export default CartWidget;
